<div class="container" [ngClass]="'status-' + status">
  <div class="content">
    <div class="info-section">
      <div class="icon">
        <img [src]="iconPath || getDefaultIconPath()" alt="" />
      </div>
      <div class="text-content">
        <p class="title">{{ title }}</p>
        <p class="description">{{ description }}</p>
      </div>
    </div>
    <div class="actions" *ngIf="actionButton">
      <lib-ui-button *ngIf="status !== 'error'"
        [variant]="buttonVariant || getDefaultButtonVariant()"
        size="l"
        [fullWidth]="false"
        (click)="clickEvent.emit($event)"
        [label]="buttonText"
      ></lib-ui-button>
      <button  #errorButton *ngIf="status === 'error'" class="error-button" (click)="clickEvent.emit($event)">
        {{buttonText}}
      </button>
    </div>
  </div>
</div>
